import { toast } from 'react-toastify';
import { send } from './requests';

/**
 * get type of project from type id
 * @param {number} type
 * @returns {string}
 */
function getTypeString(type) {
  switch (type) {
    case 2:
      return 'video';
    case 3:
      return '3d';
    default:
      return 'photo';
  }
}

function newWork(title, company, file, type, thumbnail, width, height) {
  const formData = new FormData();
  formData.append('title', title);
  formData.append('details', company);
  formData.append('category_id', type);
  formData.append('index', 0);
  formData.append('file', file);
  if (height) formData.append('height', height);
  if (width) formData.append('width', width);
  const typepro = getTypeString(type);
  formData.append('type', typepro);
  if (thumbnail) {
    formData.append('thumbnails', thumbnail);
  }
  return send('works', {
    method: 'POST',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}

function updateWork(id, title, company, file, type, thumbnail, width, height) {
  const typepro = getTypeString(type);
  const formData = new FormData();
  if (title) formData.append('title', title);
  if (company) formData.append('details', company);
  if (height) formData.append('height', height);
  if (width) formData.append('width', width);
  if (type) {
    formData.append('category_id', type);
    formData.append('type', typepro);
  }
  if (file) formData.append('file', file);
  if (thumbnail) formData.append('thumbnails', thumbnail);
  return send(`works/${id}/update`, {
    method: 'POST',
    data: formData
  });
}

async function getWorks(categoryId = 0) {
  try {
    const response = await send(`works?count=200${categoryId ? `&category=${categoryId}` : ''}`);
    const { success, data } = response.data;
    if (!success || !data) return [];
    return data;
  } catch (e) {
    toast.error('Error in get list of works');
    return [];
  }
}

async function moveWork(items) {
  const indexes = {};
  items.forEach((item, index) => {
    indexes[item.id] = index + 1;
  });
  const response = await send('works/indexes', { data: indexes, method: 'POST' });

  const result = response.data.success;
  if (result) toast.success('Work position changed successfully');
  return result;
}

/**
 * @param {number} id
 */
const getWork = async (id) => (await send(`works/${id}`)).data.data;

/**
 * @param {number} id
 */
async function deleteWork(id) {
  return send(`works/${id}`, {
    method: 'DELETE'
  });
}

export { getWorks, moveWork, newWork, deleteWork, getWork, updateWork };
